import {EmployeeRef, HibobOffice, WorkSite} from "../../api/Model";
import {Box, Tooltip} from "@mui/material";
import React, {useEffect, useState} from "react";
import {noop} from "../../util/FunctionUtil";
import {ColorChip} from "../color-chip/ColorChip";
import {badgeOrDefault, useWorkSiteMapStore} from "../../api/WorkSiteMapStore";
import {Opt} from "../../util/Optional";


export function SiteChip({employee, siteId, hibobOfficeId}: {
    employee: EmployeeRef,
    siteId?: never,
    hibobOfficeId?: never,
} | {
    employee?: never,
    siteId?: Opt<WorkSite['id']>,
    hibobOfficeId?: Opt<HibobOffice['id']>,
}) {
    const workSites = useWorkSiteMapStore(state => state.remoteValue);

    const [chip, setChip] = useState<{
        label: string,
        tooltip: string,
        color: Opt<string>,
        emoji: Opt<string>,
    }>();
    useEffect(() => {
        workSites.resolve(map => {
            const residence = employee
                ? map.residenceByEmployee(employee)
                : map.residencyById(siteId, hibobOfficeId);

            setChip({
                label: residence.hibobOffice ? (
                        badgeOrDefault(residence.hibobOffice)
                    ) : (
                        badgeOrDefault(residence.workSite)
                    ),
                tooltip: residence.hibobOffice ? `${residence.workSite.name} | ${residence.hibobOffice.name}` : residence.workSite.name,
                color: residence.hibobOffice?.color || residence.workSite?.color,
                emoji: residence.workSite.emoji,
            });
        });
    }, [siteId, hibobOfficeId, employee, setChip, workSites]);

    return chip ? (
        <Tooltip
            title={chip.tooltip}>
            <ColorChip
                icon={chip.emoji ? <Box px={0.5}>{chip.emoji}</Box> : undefined}
                label={chip.label}
                variant="filled"
                size="small"
                color={chip.color || undefined}
                onClick={noop}
                clickable={false}
            />
        </Tooltip>
    ) : null;
}